import { SerializedNodes } from "@craftjs/core";

export const DownloadsPage: SerializedNodes = {
    ROOT: {
        type: { resolvedName: "Page" },
        isCanvas: true,
        props: { title: "Untitled Page", language: "int-en", pageType: "Downloads" },
        displayName: "Page",
        custom: { displayName: "Page" },
        hidden: false,
        nodes: ["dsCVJyOHPj", "cQYjvL5VWy", "as3Ks2b4d"],
        linkedNodes: {},
        parent: null,
    },
    dsCVJyOHPj: {
        type: { resolvedName: "DownloadsHeader" },
        isCanvas: true,
        props: {},
        displayName: "Header",
        custom: { canDelete: false, displayName: "Header Section" },
        parent: "ROOT",
        hidden: false,
        nodes: [],
        linkedNodes: {},
    },
    cQYjvL5VWy: {
        type: { resolvedName: "DownloadsContent" },
        isCanvas: true,
        props: {},
        displayName: "Content",
        custom: { canDelete: false, displayName: "Content section" },
        parent: "ROOT",
        hidden: false,
        nodes: [],
        linkedNodes: {},
    },
    as3Ks2b4d: {
        type: { resolvedName: "DownloadsSpotlight" },
        isCanvas: true,
        props: { nextStep: "2" },
        displayName: "Spotlight",
        custom: { canDelete: false, displayName: "Spotlight Section" },
        parent: "ROOT",
        hidden: false,
        nodes: [],
        linkedNodes: {},
    },
};
